export enum RadioGroupDisplayConstants {
  Inline = "inline",
  Stacked = "stacked"
}